/**
 * Gets the props to disable in search
 *
 * Returns an array with the props that should be used to disable items in the
 * user search in the merge contact modal.
 */
export function getPropsToDisableInSearch(targetUser, disabledProps = ['email', 'phone_number']) {
    const propsToDisable = [];
    disabledProps.forEach((prop) => {
        if (targetUser === null || targetUser === void 0 ? void 0 : targetUser[prop]) {
            propsToDisable.push(prop);
        }
    });
    return propsToDisable;
}
